import { useState } from "react"

import createContextFactory from "@Utils/factory"

const { Provider, useContext } = createContextFactory(useTableLocal)

export {
  useContext as useTableContext,
  Provider as TableProvider,
}

function useTableLocal() {
  const [columnWidths, setColumnWidths] = useState({})
  const [activeResizeColumn, setActiveResizeColumn] = useState(null)
  const [resizedColumns, setResizedColumns] = useState([])

  return {
    columnWidths,
    setColumnWidths,
    activeResizeColumn,
    setActiveResizeColumn,
    resizedColumns,
    setResizedColumns,
  }
}
